import { useTranslation } from "react-i18next";
import { formatDate, InfoDrawerMeta } from "@inductiveautomation/ws-components";

import {
  CertificationActionCallback,
  ElectiveWithType,
} from "../Training.types";
import CourseProgressSection from "./sections/CourseProgress";

const CourseContent = ({
  certification,
}: {
  certification: ElectiveWithType | undefined;
  onAction: CertificationActionCallback;
}) => {
  const { t } = useTranslation();
  if (!certification) return null;

  return (
    <>
      <InfoDrawerMeta
        heading={t("training.drawer.headings.details")}
        parentTestId="training-drawer"
        fields={[
          {
            label: t("training.drawer.headings.completed"),
            value: certification.completedAt
              ? formatDate(certification.completedAt, "date")
              : "–",
          },
        ]}
      />

      <CourseProgressSection progress={certification.courseProgress} />
    </>
  );
};

export default CourseContent;
